import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Container,
  Image,
  Button,
  Form,
  InputGroup,
  OverlayTrigger,
  Popover,
  ButtonGroup,
} from "react-bootstrap";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {
  DonateNowSection,
  DonateNowWrapper,
  Title,
  BasketSummary,
  BasketWrapper,
  SummaryLeft,
  SummaryRight,
  SummaryTitle,
  SummaryBox,
  BoxTitle,
  Foundation,
  SummaryTotal,
  TotalTile,
  DonateDelete,
  Icon,
  CustomCheckbox,
  PopoverSection,
  SummaryBlueBox,
  CustomRadioBox,
  CheckBoxText,
  TotalList,
  TotalItem,
  SubTitle,
  TotalAmount,
  SummaryRightWrapper,
  CaptchaImage,
  DonationWrapper,
  DonateImageCol,
  RadioBox,
  EmptyBasket,
} from "./donateNowStyle";
import Trash from "../../assests/images/trash.svg";
import ToolIcon from "../../assests/images/component.svg";
import DonateImage from "../../assests/images/donation.svg";
import CustomUsdField from "../../components/common/commonUsdDonate/CustomUsdField";
import { MESSAGE } from "../../utils/message";
import SearchBox from '../../components/common/searchBox/searchBox';
import * as Yup from "yup"
import {
  CreateOrderActions,
  CreateOrderData,
  OnApproveData,
  OnApproveActions,
} from "@paypal/paypal-js";
import { useDispatch, useSelector } from "react-redux";
import { donateCartHandler } from "../../redux/slices/donationCamp/donateCart-slice";
import { CartListItem, DonationFormProps } from "../../utils/types";
import { useFormik } from "formik";
import { deleteCartDonateHandler, editCartDonateHandler } from "../../redux/slices/donationCamp/addCartDonate-slice";
import { donateToHandler } from "../../redux/slices/donationCamp/donateTo-slice";
import { useNavigate } from "react-router-dom";
import MetaComponent from "../../components/common/metaComponent";

const popover = (
  <PopoverSection>
    <Popover className="popover-basic">
      <Popover.Body>
        After completing your donation, you will receive a link to a
        downloadable certificate with your honoree's name that you can use a
        gift.
      </Popover.Body>
    </Popover>
  </PopoverSection>
);
const popoverDelete = (
  <PopoverSection>
    <Popover className="delete-btn">
      <Popover.Body>
        Remove this nonprofit from your basket.
      </Popover.Body>
    </Popover>
  </PopoverSection>
);
const popoverDonateTip = (
  <PopoverSection>
    <Popover className="popover-basic">
      <Popover.Body>
        We have partnered with PayPal Giving Fund, a nonprofit organization
        that operates a donor- advised fund, to disburse donations made
        through GreatNonprofits to support other nonprofit organizations.
        Payment processing fees apply for donations, but GreatNonprofits
        does not charge a fee for its services. Your added tip helps us get
        more donations to nonprofits doing important work.
      </Popover.Body>
    </Popover>
  </PopoverSection>
);

const DonateNowPage = () => {
  const donation_id: any = typeof localStorage !== "undefined" && localStorage.getItem("donation_id")
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [error, setError] = useState<any>([]);
  const cartData: CartListItem[] = useSelector(
    (state: any) => state?.donateCart?.data?.results
  );



  const cartValues = useMemo(() => {
    let tempCartValues = {
      subTotal: 0,
      tip: 0,
      total: 0
    }
    cartData?.forEach(item => {
      if (item?.is_tip === 0) {
        tempCartValues.subTotal = tempCartValues?.subTotal + item.amount
      } else {
        tempCartValues.tip = tempCartValues?.tip + item.amount
      }
    }
    )
    tempCartValues.total = tempCartValues.subTotal + tempCartValues.tip
    return tempCartValues
  }, [cartData])


  const onCreateOrder = (
    _data: CreateOrderData,
    actions: CreateOrderActions
  ) => {
    return actions.order
      .create({
        purchase_units: [
          {
            amount: {
              value: cartValues?.total.toString(),
              currency_code: "USD",
            },

          },
        ],
        application_context: {
          shipping_preference: "NO_SHIPPING"
        },
        intent: "CAPTURE",
      }).then((res) => {
        return res;
      })
    // .catch((err) => {
    //   console.log("ORDER CREATE FAILED", err);
    //   return err;
    // });
  };
  const handleButtonClick = () => {
    const url = `/organizations/find`;
    if (url) {
      window.open(url, '_parent');
    }
  };
  const onApproveOrder = async (
    _data: OnApproveData,
    actions: OnApproveActions
  ): Promise<void> => {
    if (actions.order) {
      return await actions.order
        .capture()
        .then((details) => {
          if (details?.id) {
            dispatch(donateToHandler(details?.id, donation_id ?? undefined) as any).then((_: any) => {
              navigate(`/donations/confirmation?pid=${details?.id}`)
            })

          }
        })
        .catch((err) => {
          console.log("ORDER APPROVE FAILED", err);
          return err;
        });
    }
    return new Promise(() => { });
  };
  useEffect(() => {

    dispatch(donateCartHandler(donation_id ?? undefined) as any);
  }, []);

  const handleError = (e: any, index: any) => {
    if (error?.length > 0) {
      const checkId = error?.filter((item: any) => item?.id == index)
      if (checkId?.length > 0) {
        const update = error?.map((item: any) => {
          return (
            item?.id == index ? { ...item, error: e } : item
          )
        })
        setError(update)
      } else {
        setError([...error, { id: index, error: e }])
      }
    } else {
      setError([...error, { id: index, error: e }])
    }
  }

  const checkError = useCallback((error: any) => {
    const checkAll = error?.filter((item: any) => {
      return Object.keys(item?.error)?.length > 0;
    })

    return checkAll?.length > 0 ? true : false
  }, [error]);

  return (
    <>
      <MetaComponent
        keywords="nonprofits, non-profits, not for profits, volunteer, donate, donation, volunteering, ratings, rate, best non-profits, best nonprofits, best charities, top nonprofits, top charities, top non-profits, charitable giving, giving to nonprofits"
        description="Find and review charities, nonprofits and volunteering and donation opportunities. Want to donate or volunteer? Find the best non-profit or charity"
        ogTitle="Donations Checkout"
        ogDescription="Find and review charities, nonprofits and volunteering and donation opportunities. Want to donate or volunteer? Find the best non-profit or charity"
        ogUrl="https://qa.greatnonprofits.org/donations/"
        ogImage="https://devcdn.greatnonprofits.org/img/gnp-facebook-share-lg.png"
      />

      <DonateNowSection>
        <DonateNowWrapper>
          <Container className="cont-w">
            <Title>{MESSAGE.givingBasketSummaryText}</Title>
            {/* <ReviewSerch /> */}
            <SearchBox />
          </Container>
        </DonateNowWrapper>
      </DonateNowSection>
      <BasketSummary>
        <Container className="cont-w">
          <BasketWrapper>
            <SummaryLeft className="carttext-col" >
              <SummaryTitle>{MESSAGE.basketSummaryText}</SummaryTitle>
              {cartData?.length > 0 ? (
                cartData.map((item: CartListItem, index: number) => (
                  <CartItemComponent
                    cartData={item}
                    key={item.id}
                    handleError={(e: any, index: any) => { handleError(e, index) }}
                    refresh={() => {
                      dispatch(donateCartHandler(donation_id ?? undefined) as any);
                    }}
                  />
                ))
              ) : (
                <>
                  <EmptyBasket>
                    {MESSAGE.emptyBasketMessage}
                  </EmptyBasket>
                  <Button onClick={handleButtonClick}>
                    {MESSAGE.findMoreNonprofitsBtn}
                  </Button>
                  <EmptyBasket>{MESSAGE.noDonationInBasket}</EmptyBasket>
                </>
              )}
            </SummaryLeft>
            <SummaryRight className="sahdad">
              <SummaryRightWrapper>
                <SummaryTotal>
                  <TotalTile>{MESSAGE.summary}</TotalTile>
                  <TotalList>
                    <TotalItem>
                      <SubTitle>{MESSAGE.subTotal}</SubTitle>
                      <TotalAmount>
                        ${cartValues?.subTotal} {MESSAGE.usd}
                      </TotalAmount>
                    </TotalItem>
                    <TotalItem>
                      <SubTitle>{MESSAGE.tip}</SubTitle>
                      <TotalAmount>{`$${cartValues?.tip
                        } USD`}</TotalAmount>
                    </TotalItem>
                  </TotalList>
                  <TotalList className="TotalAmount">
                    <TotalItem>
                      <SubTitle>{MESSAGE.total}:</SubTitle>
                      <TotalAmount>
                        $
                        {cartValues?.total}{" "}
                        {MESSAGE.usd}
                      </TotalAmount>
                    </TotalItem>
                  </TotalList>
                </SummaryTotal>
                <CaptchaImage>
                  <PayPalScriptProvider

                    options={{

                      environment: "sandbox",
                      currency: "USD",
                      intent: "capture",
                      clientId:
                        "ATjVvbtQKeDxYvbjqGR8iWQIACa-b78kFszoRDLxMfsOEtZPCADD9QPyM2TDSAQHPK7eyhVL_wVMzZFm",
                    }}
                  >
                    <PayPalButtons
                      forceReRender={[cartValues]}
                      onError={(error) => { console.log("PayPal Error", error) }}
                      style={{ layout: "vertical" }}
                      createOrder={(data, actions) =>
                        onCreateOrder(data, actions)
                      }
                      onApprove={(data, actions) =>
                        onApproveOrder(data, actions)
                      }

                      disabled={checkError(error)}
                    />
                  </PayPalScriptProvider>
                </CaptchaImage>
              </SummaryRightWrapper>

              <DonationWrapper>
                <DonateImageCol>
                  <Image src={DonateImage} alt="DonateImage" />
                </DonateImageCol>
              </DonationWrapper>
            </SummaryRight>
          </BasketWrapper>
        </Container>
      </BasketSummary>
    </>
  )
};
interface CartItemCProps {
  cartData: CartListItem;
  refresh: () => void;
  handleError: any;
}
const CartItemComponent = memo(({ cartData, refresh, handleError }: CartItemCProps) => {
  const dispatch = useDispatch()
  const submitButtonRef = useRef<HTMLButtonElement | null>(null);
  const handleDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    dispatch(deleteCartDonateHandler(cartData?.id) as any).then(refresh)
  }
  const memoryTypeEnable = useMemo(() => {
    if (cartData?.memorial_type) {
      return true
    } else {
      return false
    }
  }, [cartData])
  const formik = useFormik<DonationFormProps & { memoryTypeEnable: boolean }>({
    initialValues: {
      amount: cartData?.amount,
      share_data: cartData?.share_data,
      memoryTypeEnable: memoryTypeEnable,
      memorial_type: cartData?.memorial_type,
      memorial_name: cartData?.memorial_name,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      amount: Yup.number().min(1, MESSAGE.requiredErrors("Minimum amount")).required(MESSAGE.requiredErrors("Amount")),
      share_data: Yup.boolean(),
      memoryTypeEnable: Yup.boolean(),
      memorial_type: Yup.string().trim().when("memoryTypeEnable", {
        is: true,
        then: (schema) => schema.required(MESSAGE.requiredErrors("Memorial Type"))
      }),
      memorial_name: Yup.string().trim().when("memoryTypeEnable", {
        is: true,
        then: (schema) => schema.required(MESSAGE.requiredErrors("Memorial Name"))
      })
    }),
    onSubmit: (values: DonationFormProps) => {
      dispatch(editCartDonateHandler(cartData?.id, values) as any).then(refresh)
    },
  });

  useEffect(() => {
    if (formik?.errors) {
      handleError(formik?.errors, cartData?.id);
    }
  }, [formik])

  return (
    <SummaryBox>
      <Form onSubmit={formik.handleSubmit}>
        <Button ref={submitButtonRef} type="submit" hidden />
        {cartData?.is_tip === 0 ? (
          <>
            <Foundation>
              <BoxTitle>{cartData?.title}</BoxTitle>
              <DonateDelete>
                <div>
                  <CustomUsdField
                    value={formik.values?.amount}
                    onChange={formik.handleChange}
                    onBlur={() => {
                      if (formik.initialValues.amount !== formik.values?.amount) {
                        submitButtonRef?.current?.click();
                      }
                    }}
                  />
                  {formik.errors.amount &&
                    <div className="error">
                      <p>{formik.errors.amount}</p>
                    </div>}
                </div>
                <Icon>
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="bottom"
                    overlay={popoverDelete}
                  >

                    <Button onClick={handleDelete} className="tooltipBtn">
                      <Image src={Trash} alt="Trash" />
                    </Button>
                  </OverlayTrigger>
                </Icon>
              </DonateDelete>

            </Foundation>

            <CustomCheckbox>
              <Form.Check
                className="checkbox"
                checked={formik.values?.memoryTypeEnable}
                onChange={(e) => {
                  if (e.target.checked === false) {
                    formik.setFieldValue("memorial_type", "");
                    formik.setFieldValue("memorial_name", "");
                    submitButtonRef?.current?.click();
                  } else {
                    formik.setFieldValue("memorial_type", "in_honor");
                  }
                  formik.setFieldValue("memoryTypeEnable", e.target.checked)
                }}
              />
              <label htmlFor="CheckBtn3" className="form-check-label">
                {MESSAGE.donateMsg1}
              </label>
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement="bottom"
                overlay={popover}
              >
                <Button className="tooltipBtn ">
                  <Image src={ToolIcon} alt="ToolIcon" />
                </Button>
              </OverlayTrigger>
            </CustomCheckbox>

            {formik.values.memoryTypeEnable && (
              <SummaryBlueBox>
                <RadioBox>
                  <CustomRadioBox>
                    <Form.Check
                      type="radio"
                      name="memorial_type"
                      value="in_honor"
                      checked={formik?.values?.memorial_type === "in_honor"}
                      label="In honor of"
                      onChange={() => {
                        formik.setFieldValue("memorial_type", "in_honor");
                        submitButtonRef?.current?.click();
                      }}
                    />
                  </CustomRadioBox>

                  <CustomRadioBox>
                    <Form.Check
                      type="radio"
                      name="memorial_type"
                      value="in_memory"
                      checked={formik.values.memorial_type === "in_memory"}
                      label="In memory of"
                      onChange={() => {
                        formik.setFieldValue("memorial_type", "in_memory");
                        submitButtonRef?.current?.click();
                      }}
                    />
                  </CustomRadioBox>
                </RadioBox>
                <Form>
                  <InputGroup>
                    <Form.Control
                      className="inputbox"
                      placeholder="Enter Here"
                      aria-label="Enter Here"
                      name="memorial_name"
                      id="memorial_name"
                      value={formik.values?.memorial_name}
                      onChange={formik.handleChange}
                      onBlur={(_) => submitButtonRef?.current?.click()}
                    />

                  </InputGroup>
                  {(formik?.errors?.memorial_name && formik?.touched?.memorial_name) && <div className="error">
                    <p>{"Please provide above details"}</p>
                  </div>}
                </Form>
              </SummaryBlueBox>
            )}

            <CustomCheckbox>
              <Form.Check
                className="checkbox"
                aria-label="option 1"
                id="share_data"
                name="share_data"
                checked={formik.values.share_data}
                onChange={formik.handleChange}
                onBlur={(_) => submitButtonRef?.current?.click()}
              />
              <label htmlFor="CheckBtn1" className="form-check-label">
                {MESSAGE.donateMsg2}
              </label>
            </CustomCheckbox>
            <CheckBoxText>{MESSAGE.donateNowDesc}</CheckBoxText>
          </>
        ) : (
          <>
            <Foundation>
              <CustomCheckbox>
                <BoxTitle>{MESSAGE.donateTipMsg}</BoxTitle>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="bottom"
                  overlay={popoverDonateTip}
                >
                  <Button className="tooltipBtn ">
                    <Image src={ToolIcon} />
                  </Button>
                </OverlayTrigger>
              </CustomCheckbox>
              <DonateDelete>
                <div>

                  <CustomUsdField
                    value={formik.values.amount}
                    onChange={formik.handleChange}
                    onBlur={() => submitButtonRef?.current?.click()}
                  />
                  {formik.errors.amount &&
                    <div className="error">
                      <p>{formik.errors.amount}</p>
                    </div>}
                </div>
                <Icon>
                  <Button onClick={handleDelete}>
                    <Image src={Trash} />
                  </Button>
                </Icon>
              </DonateDelete>
            </Foundation>
            <CheckBoxText className="TextCol">
              {MESSAGE.chargeFeeMsg}
            </CheckBoxText>
            <CheckBoxText className="TextCol">
              {MESSAGE.donateMsg3}
            </CheckBoxText>
          </>
        )}
      </Form>
    </SummaryBox>
  );
});

export default DonateNowPage;
